import React from 'react'
import {Card, CardContent} from '@/components/ui/card'
import Heading from '../typography/heading'
import GoalBannerProgressBar from './goalBannerProgressBar'
import GoalBannerBtn from './goalBannerBtn'
import GoalLevelCopy from './goalLevelCopy'
import PropTypes from 'prop-types'

const LevelCard = ({level, index, enrollment, sfccLearningCenterData}) => {
    return (
        <Card
            className="bg-white/90 p-8 flex-1 rounded-md border-gray-05 max-w-[30.75rem]"
            data-testid="levelCard"
        >
            <CardContent className="flex flex-col h-full" data-testid="levelCard-CardContent">
                <div key={index} className="py-4 text-left">
                    <Heading
                        tag="h2"
                        variant="h6"
                        content={'Level ' + (index + 1)}
                        data-testid="levelCard-Heading"
                    />
                    <GoalLevelCopy
                        level={level}
                        enrollment={enrollment}
                        data-testid="levelCard-GoalLevelCopy"
                    />
                    <GoalBannerProgressBar
                        levelData={level}
                        data-testid="levelCard-GoalBannerProgressBar"
                    />
                    <GoalBannerBtn
                        levelData={level}
                        sfccLearningCenterData={sfccLearningCenterData}
                        data-testid="levelCard-GoalBannerBtn"
                    />
                </div>
            </CardContent>
        </Card>
    )
}

LevelCard.propTypes = {
    level: PropTypes.object,
    index: PropTypes.number,
    enrollment: PropTypes.object,
    sfccLearningCenterData: PropTypes.object
}

export default LevelCard
